module.exports = require("react-modal");